/**
 * Shown on the detail page while a freshly resolved symbol is having its
 * intraday bars + news + LLM analysis backfilled. Disappears once an
 * analysis row exists OR the polling window (5 min) elapses.
 */
export default function SymbolWarmupChip({ kind }: { kind: "resolving" | "warming" }) {
  const text = kind === "resolving"
    ? "Resolving ticker via yfinance…"
    : "Warming up — intraday bars, news, and scores arriving in ~30s.";
  return (
    <div className="flex items-center gap-2 rounded-lg border border-amber-500/30 bg-amber-500/10 px-3 py-2 text-xs text-amber-200">
      <svg viewBox="0 0 20 20" fill="none" className="h-4 w-4 shrink-0 animate-spin" aria-hidden="true">
        <circle cx="10" cy="10" r="7" stroke="currentColor" strokeOpacity="0.25" strokeWidth="2" />
        <path d="M17 10a7 7 0 0 0-7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
      <span>{text}</span>
    </div>
  );
}
